import { render } from "./CxMetadataChipsFilter.vue?vue&type=template&id=1eb8d32c"
import script from "./CxMetadataChipsFilter.vue?vue&type=script&lang=js"
export * from "./CxMetadataChipsFilter.vue?vue&type=script&lang=js"

import "./CxMetadataChipsFilter.vue?vue&type=style&index=0&id=1eb8d32c&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__